// IMPORTS
// Modules
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// Components
import OneHive from './OneHive';
// Assets
import './index.scss';


// MAIN APPLICATION
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   <BrowserRouter>
      <OneHive />
   </BrowserRouter>
);